/**
 * @method getCoverageTypeOrderNumber
 * @param {String} string
 * @return {Number}
 */

import { Cell } from 'jspdf-autotable';
import { CLIENT_TYPES } from '../../constants';
import moment from 'moment';
import RadioInput from '../components/common/radio';
export function getCoverageTypeOrderNumber(CoverageType) {
  if (CoverageType === 'Medical') {
    return 1;
  }

  if (CoverageType === 'Dental') {
    return 2;
  }

  if (CoverageType === 'Vision') {
    return 3;
  }

  if (CoverageType === 'Prescription') {
    return 4;
  }
  return 5;
}

export function findPercentage(min, max) {
  let defaultPercentage = 0;
  if (min > 0) {
    defaultPercentage = (min * 100) / max;
  }
  if (defaultPercentage > 100) {
    defaultPercentage = 100;
  }
  return defaultPercentage;
}

export function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return window.btoa(binary);
}
/**

 * @method formatFacilityName : format facility name from given name params

 * @param FacilityName : string | null

 */

export function formatFacilityName(FacilityName) {
  return `${FacilityName}`;
}

export function arrayBufferToString(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return binary;
}

export function checkPermission(featureName, permissionFramework) {
  let permissionFwkLen = 0;
  let bPermissionSet = false;
  permissionFwkLen = permissionFramework?.length || 0;
  for (let idx = 0; idx < permissionFwkLen; idx++) {
    if (
      permissionFramework[idx].level === 'level-0' &&
      permissionFramework[idx].GroupName === featureName &&
      permissionFramework[idx].GroupEnabled === true
    ) {
      bPermissionSet = true;
    }

    if (
      permissionFramework[idx].level === 'level-1' &&
      permissionFramework[idx].PermissionLevel1 === featureName &&
      permissionFramework[idx].PermissionLevel1Enabled === true
    ) {
      bPermissionSet = true;
    }

    if (
      permissionFramework[idx].level === 'level-2' &&
      permissionFramework[idx].PermissionLevel2 === featureName &&
      permissionFramework[idx].PermissionLevel2Enabled === true
    ) {
      bPermissionSet = true;
    }

    if (
      permissionFramework[idx].level === 'level-3' &&
      permissionFramework[idx].PermissionLevel3 === featureName &&
      permissionFramework[idx].PermissionLevel3Enabled === true
    ) {
      bPermissionSet = true;
    }

    if (
      permissionFramework[idx].level === 'level-4' &&
      permissionFramework[idx].PermissionLevel4 === featureName &&
      permissionFramework[idx].PermissionLevel4Enabled === true
    ) {
      bPermissionSet = true;
    }
  }
  return bPermissionSet;
}

export function getClientType(width = 0) {
  if (width > 600 && width < 960) {
    return CLIENT_TYPES.TABLET;
  }
  if (width < 600 && width > 0) {
    return CLIENT_TYPES.MOBILE;
  }
  return CLIENT_TYPES.WEB;
}

export function getMediaByValue(arr, value) {
  const result = arr.filter((o) => {
    return o.MediaType === value;
  });
  return result ? result[0] : null; //or undefined
}

export const getViewEmployeeDetails = (data, isDependent = false) => {
  const empData = {};
  //empData.Title = data.Title;
  empData.Suffix = data.Suffix;
  empData.Gender = isDependent ? data.DepGender : data.Gender;
  empData.LastName = isDependent ? data.DepLastName : data.LastName;
  empData.FirstName = isDependent ? data.DepFirstName : data.FirstName;
  empData.BirthDate = data.DateofBirth;
  empData.MiddleName = isDependent ? data.DepMiddleName : data.MiddleName;
  empData.NumberOfDependents = data.NumberofDependents;
  empData.SocialSecurityNumber = isDependent
    ? data.DepSocialSecurityNumber
    : data.SocialsecurityNumber;
  empData.Family = data.Family === 'true' ? true : false;
  empData.AlternateID1 = isDependent
    ? data.AlternativeID1
    : data.AlternativeID1;
  empData.AlternateID2 = isDependent
    ? data.AlternativeID2
    : data.AlternativeID2;
  //empData.LoggedInMemberType = data.LoggedInMemberType;
  empData.MemberID = data.MemberID;
  empData.MemberCertificateNumber = data.MemberCertificateNumber;
  empData.CertificateNumber = isDependent
    ? data.DepCertificateNumber
    : data.Certificatenumber;
  if (data.Age || data.DepAge) {
    empData.Age = isDependent ? data.DepAge : data.Age;
  }
  if (data.MartialStatus) {
    empData.MartialStatus = data.MartialStatus;
  }
  empData.MemberOIDClaims = data.TempID;
  empData.Status = data.Status;
  empData.Race = isDependent ? data.DepRace : data.Race;
  return empData;
};

export const getEmployeeDetails = (data) => {
  const empData = {};
  empData.OID = data.OID;
  empData.Title = data.Title;
  empData.Suffix = data.Suffix;
  empData.Gender = data.Gender;
  empData.LastName = data.LastName;
  empData.FirstName = data.FirstName;
  empData.BirthDate = data.BirthDate;
  empData.MiddleName = data.MiddleName;
  empData.NumberOfDependents = data.NumberOfDependents;
  empData.SocialSecurityNumber = data.SocialSecurityNumber;
  empData.Family = data.Family === 'true' ? true : false;
  empData.AlternateID1 = data.AlternateID1;
  empData.AlternateID2 = data.AlternateID2;
  empData.LoggedInMemberType = data.LoggedInMemberType;
  empData.MemberID = data.MemberID;
  empData.MemberCertificateNumber = data.MemberCertificateNumber;
  empData.CertificateNumber = data.CertificateNumber;
  if (data.Age) {
    empData.Age = data.Age;
  }
  if (data.MaritalStatus) {
    empData.MaritalStatus = data.MaritalStatus;
  }
  empData.MemberOIDClaims = data.TempID;
  return empData;
};

export function formatDependentName(userInfo) {
  return `${userInfo.Title ? userInfo.Title : ''} ${
    userInfo.DepLastName ? userInfo.DepLastName : ''
  }${userInfo.DepFirstName ? ', ' + userInfo.DepFirstName : ''} ${
    userInfo.DepMiddleName ? userInfo.DepMiddleName : ''
  } ${userInfo.DepSuffix ? userInfo.DepSuffix : ''}`;
}

export const getEmploymentDetails = (data) => {
  const empData = {};
  empData.BlockOfBusinessId = data.BlockOfBusinessId;
  empData.BlockOfBusinessOid = data.BlockOfBusinessOid;
  empData.BlockOfBusinessName = data.BlockOfBusinessName;
  empData.ClientId = data.ClientId;
  empData.ClientOid = data.ClientOid;
  empData.ClientName = data.ClientName;
  empData.Department = data.Department;
  empData.LocationName = data.LocationName;
  empData.EmploymentStartDate = data.EmploymentStartDate;
  return empData;
};

export const getViewEmploymentDetails = (data) => {
  const empData = {};
  empData.BlockOfBusinessId = data.BlockofBusinessID;
  //empData.BlockOfBusinessOid = data.BlockOfBusinessOid;
  empData.BlockOfBusinessName = data.BlockofBusinessName;
  empData.ClientId = data.ClientID;
  //empData.ClientOid = data.ClientOid;
  empData.ClientName = data.ClientName;
  empData.Department = data.Department;
  empData.LocationName = data.Location;
  empData.EmploymentStartDate = data.EmploymentStartDate;
  return empData;
};

export const getViewContactInformation = (data, isDependent = false) => {
  const empData = {};
  empData.WorkPhone = data.WorkPhone1;
  empData.HomePhone = data.HomePhone1;
  empData.MobilePhone = data.MobilePhone1;
  empData.Email1 = isDependent ? data.Email1 : data.Email;
  empData.Email2 = data.AlternativeEmail;
  return empData;
};

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

export const frameColumns = (TotalDeposit, TotalWithdrawl) => {
  const columnsList = [
    {
      Header: 'Transaction Date',
      accessor: 'ProcessedDate',
      Footer: 'Total',
    },
    {
      Header: 'Description',
      accessor: 'Description',
      Footer: '',
    },
    {
      Header: 'Claim Number',
      accessor: 'ClaimNumber',
      sortType: 'basic',
      Footer: '',
    },
    {
      Header: 'Contribution Amount',
      accessor: 'Deposit',
      Footer: TotalDeposit,
      sortType: 'basic',
    },
    {
      Header: 'Payment Amount',
      accessor: 'Withdrawl',
      Footer: TotalWithdrawl,
      sortType: 'basic',
    },
    {
      Header: 'Balance',
      accessor: 'Balance',
      Footer: '',
      sortType: 'basic',
    },
    {
      Header: 'Status',
      accessor: 'Status',
      Footer: '',
    },
  ];

  return columnsList;
};

export const frameColumnsForClaims = () => {
  const columnsList = [
    {
      Header: 'Service Date',
      accessor: 'ServiceDate',
      Footer: '',
      sortType: (a, b) => {
        const a1 = new Date(a).getDate();
        const b1 = new Date(b).getDate();
        if (a1 < b1) return 1;
        else if (a1 > b1) return -1;
        else return 0;
      },
    },
    {
      Header: 'Patient Name',
      accessor: 'PatientName',
      Footer: '',
    },
    {
      Header: 'Claim Type',
      accessor: 'Product',
      Footer: '',
    },
    {
      Header: 'Claim Number',
      accessor: 'Claimnumber',
      sortType: 'basic',
      Footer: '',
    },
    {
      Header: 'Provider',
      accessor: 'ProviderName',
      Footer: '',
    },
    {
      Header: 'Status',
      accessor: 'ClaimStatus',
      Footer: '',
    },
    {
      Header: 'Amount',
      accessor: 'TotalCharge',
      Footer: '',
      sortType: 'basic',
    },
    {
      Header: 'You May Owe',
      accessor: 'TotalPaid',
      Footer: '',
      sortType: 'basic',
    },
  ];

  return columnsList;
};

export const frameColumnsForDocumentList = (DateFormate = 'MM-DD-YYYY') => {
  const columnsList = [
    {
      Header: 'Title',
      accessor: 'Title',
      Footer: '',
    },
    //{
    //Header: 'Document For',
    //accessor: 'senddocumentfor',
    //Footer: '',
    //},
    {
      Header: 'Type',
      accessor: 'Type',
      Footer: '',
    },
    //{
    //Header: 'Reference',
    //accessor: 'ReferenceNumber',
    //Footer: '',
    //},
    {
      Header: 'Sent',
      accessor: 'SentDate',
      Footer: '',
      sortType: (a, b) => {
        const a1 = new Date(a).getDate();
        const b1 = new Date(b).getDate();
        if (a1 < b1) return 1;
        else if (a1 > b1) return -1;
        else return 0;
      },
      Cell: ({ value }) => {
        return moment(value).format(DateFormate);
      },
    },
    {
      Header: 'Documents',
      accessor: 'documents',
      Footer: '',
    },
  ];

  return columnsList;
};

export const frameColumnFor_PC_RecentSearch = () => {
  const columnsList = [
    {
      Header: 'RECENT REQUESTS',
      accessor: 'request',
      Footer: '',
    },
    {
      Header: '',
      accessor: 'delete',
      disableSortBy: true,
      Footer: '',
    },
    {
      Header: '',
      accessor: 'pin',
      disableSortBy: true,
      Footer: '',
    },
    {
      Header: 'DATE',
      accessor: 'date',
      Footer: '',
    },
  ];

  return columnsList;
};
/**
 * @method formatDoctorName : format doctor name from given name params
 * @param DoctorTitle : string | null
 * @param LastName : string
 * @param FirstName : string | null
 * @param MiddleName : string | null
 * @param NameSuffix : string | null
 */
export function formatDoctorName(
  DoctorTitle,
  LastName,
  FirstName,
  MiddleName,
  NameSuffix,
) {
  return `${DoctorTitle ? DoctorTitle : ''} ${LastName ? LastName : ''}${
    FirstName ? ', ' + FirstName : ''
  } ${MiddleName ? MiddleName : ''} ${NameSuffix ? NameSuffix : ''}`;
}

/**
 * @method formatMemberName : format user name from given name params
 * @param Title : string | null
 * @param LastName : string
 * @param FirstName : string | null
 * @param MiddleName : string | null
 * @param Suffix : string | null
 */
export function formatMemberName(userInfo) {
  return `${userInfo.Title ? userInfo.Title : ''} ${
    userInfo.LastName ? userInfo.LastName : ''
  }${userInfo.FirstName ? ', ' + userInfo.FirstName : ''} ${
    userInfo.MiddleName ? userInfo.MiddleName : ''
  } ${userInfo.Suffix ? userInfo.Suffix : ''}`;
}

export function getClaimCountByValue(arr, status) {
  if (arr.some((f) => f.Status === status)) {
    const filteredArray =
      arr.filter((element) => {
        if (element.Status === status) {
          return true;
        }
        return false;
      }) || [];
    return filteredArray.length > 0 ? filteredArray[0].Count : '0';
  } else {
    return '0';
  }
}

export function apiDataGenerationForCompare({
  loggedInUserOID,
  loggedInMemberType,
  selectedCheckedItems,
  searchParamsForUI,
  searchProviderParams,
}) {
  const DATA = [];
  let billedAmountVal;

  if (searchParamsForUI?.billedamount === '') {
    billedAmountVal = Number(searchParamsForUI?.billedamount);
  } else {
    billedAmountVal = searchParamsForUI?.billedamount;
  }

  selectedCheckedItems.map((item) => {
    const obj = {
      MemberType: loggedInMemberType,
      SelEmployeeMemberOID: loggedInUserOID,
      Serviceprovider: item,
      BilledAmt: billedAmountVal,
    };
    if (searchParamsForUI?.helthProcedureData?.codeName) {
      switch (searchParamsForUI?.helthProcedureData?.codeName) {
        case 'CPT4 Codes':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CPTCode';
          break;
        case 'Revenue Codes':
          obj.RevenueCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'Revenue';
          obj.CodeDescription = 'RevenueCode';
          break;
        case 'CDT5 Dental Codes':
          obj.CDT = searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CDT';
          obj.CodeDescription = 'CDTCode';
          break;
        case 'DRG Codes':
          obj.DRGCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'DRGCode';
          obj.CodeDescription = 'DRGCode';
          break;
        case 'HCPCS Codes':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CptHCPCSCode';
          break;
        case 'CPT':
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = 'CPT';
          obj.CodeDescription = 'CptHCPCSCode';
          break;
        default:
          obj.CptHCPCSCode =
            searchParamsForUI?.helthProcedureData?.value?.toString();
          obj.CodeOption = '';
          obj.CodeDescription = '';
          break;
      }
    }
    //obj.CodeOption =  "Revenue";
    //obj.RevenueCode = "0000";
    if (searchProviderParams?.selectedNetwork?.NetworkCode) {
      obj.NetworkID = searchProviderParams?.selectedNetwork?.NetworkCode;
    }
    DATA.push(obj);
    return;
  });
  return DATA;
}

export const getDataByClaimID = (ClaimsList) => {
  const listObject = [];
  let list = [];
  if (ClaimsList && ClaimsList.length > 0) {
    list = ClaimsList.map((data) => {
      if (data !== undefined) {
        const requestUrl = data?.config?.url;
        const splitMasterId = requestUrl.split('claimId/')[1];
        const claimId = splitMasterId.split('/')[0];
        const claimDetails = data?.data?.Response?.ReadClaimDTO;
        if (claimDetails) {
          listObject.push({ claimId: claimId, data: claimDetails });
        }
        return list;
      }
      return;
    });
  }
  return listObject;
};

export const getPriceCompareRecentSearchFormattedData = (data) => {
  const formattedData = [];
  if (data?.length > 0) {
    data.map((item, index) => {
      if (
        item?.requestObj &&
        item?.responseObj?.PriceCompareResponse?.length > 0
      ) {
        const ClaimStatus = {};
        let ClaimStatusArr = [];
        if (item?.responseObj?.PriceCompareResponse[0]?.ServiceProvider) {
          item?.requestObj?.comparison?.selectedCheckedItems?.forEach((val) => {
            ClaimStatusArr = item?.responseObj?.PriceCompareResponse.filter(
              (f) => f.ServiceProvider === val,
            );
            ClaimStatus[val] =
              ClaimStatusArr && ClaimStatusArr.length > 0
                ? ClaimStatusArr[0].ClaimStatus === 'InProgress'
                  ? 'In-Progress'
                  : 'Available'
                : null;
          });
        } else {
          item?.requestObj?.comparison?.selectedCheckedRowData?.forEach(
            (val) => {
              ClaimStatusArr = item?.responseObj?.PriceCompareResponse.filter(
                (f) =>
                  (f.FacilityTAX === val.TaxID ||
                    f.FacilityTAX === val.TaxId) &&
                  f.ProviderNPI === val.NationalProviderId,
              );
              ClaimStatus[val.ConnectorId] =
                ClaimStatusArr && ClaimStatusArr.length > 0
                  ? ClaimStatusArr[0].ClaimStatus === 'InProgress'
                    ? 'In-Progress'
                    : 'Available'
                  : null;
            },
          );
        }

        const itemOBJ = {
          request: {
            requestBy: item?.requestBy,
            serviceForOid:
              item?.requestObj?.searchParams?.procedureForData?.value,
            serviceFor: item?.requestObj?.searchParams?.procedureForData?.label,
            providers:
              item?.requestObj?.searchParams?.providerType === 'facility'
                ? item?.requestObj?.comparison?.selectedCheckedRowData?.map(
                    (data) => {
                      const dName = formatFacilityName(data?.FacilityName);
                      const dStatus =
                        ClaimStatus[data.ConnectorId] !== null
                          ? ' (' + ClaimStatus[data.ConnectorId] + ')'
                          : '';
                      return dName + dStatus;
                    },
                  )
                : item?.requestObj?.comparison?.selectedCheckedRowData?.map(
                    (data) => {
                      const dName = formatDoctorName(
                        data?.DoctorTitle,
                        data?.LastName,
                        data?.FirstName,
                        data?.MiddleName,
                        data?.Suffix,
                      );

                      const dStatus =
                        ClaimStatus[data.ConnectorId] !== null
                          ? ' (' + ClaimStatus[data.ConnectorId] + ')'
                          : '';
                      return dName + dStatus;
                    },
                  ),
            requestTitle:
              item?.requestObj?.searchParams?.helthProcedureData?.label,
          },
          delete: false,
          pin: item?.pinned,
          date: Date.parse(item?.requestTime),
          id:
            item?.responseObj?.PriceCompareResponse?.length > 0 &&
            item?.responseObj?.PriceCompareResponse[0]?.RequestId,
        };
        formattedData.push(itemOBJ);
      }
      return;
    });
    return formattedData;
  } else {
    return [];
  }
};

export const showNetworkName = (networkList, item) => {
  let showLabel = '';
  const selectedItem = networkList.filter((f) => f.NetworkName === item);
  showLabel =
    selectedItem && selectedItem.length
      ? selectedItem[0].Portal_Display_Label
      : '';

  return showLabel;
};

export const frameColumnsForAdditionalPaymentDetails = () => {
  const columnsList = [
    {
      Header: 'PAYMENT ID',
      accessor: 'PaymentId',
      Footer: '',
    },
    {
      Header: 'DATE',
      accessor: 'PayDate',
      Footer: '',
    },
    {
      Header: 'METHOD',
      accessor: 'PaymentMethod',
      Footer: '',
    },
    {
      Header: 'CHECKING ACCOUNTS',
      accessor: 'CheckingAccounts',
      Footer: '',
    },
    {
      Header: 'RECONCILIATION',
      accessor: 'PaymentReconciliationStatus',
      Footer: '',
    },
    {
      Header: 'AMOUNT',
      accessor: 'PaymentAmount',
      Footer: '',
    },
    {
      Header: 'DOWNLOAD EOP',
      accessor: 'DownloadEOP',
      Footer: '',
    },
  ];

  return columnsList;
};

export const frameColumnsForClaimsDocuments = () => {
  const columnsList = [
    {
      Header: 'Title',
      accessor: 'Title',
      Footer: '',
    },
    {
      Header: 'File',
      accessor: 'File',
      Footer: '',
    },
    {
      Header: 'Download',
      accessor: 'Download',
      Footer: '',
    },
  ];

  return columnsList;
};

export const frameColumnsForAccountPreferenceDualCoverageTable = (
  selectedRow,
  onDualCoverageRadioChange,
) => {
  const columnsList = [
    {
      Header: 'Id',
      accessor: 'id',
      Footer: '',
      width: 10,
      minWidth: 10,
      maxWidth: 10,
    },
    {
      Header: 'Account',
      accessor: 'account',
      Footer: '',
      width: 200,
      minWidth: 150,
      maxWidth: 250,
    },
    {
      Header: 'User Type',
      accessor: 'userType',
      Footer: '',
      width: 125,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      Header: 'Status',
      accessor: 'status',
      width: 110,
      minWidth: 100,
      maxWidth: 120,
      Cell: ({ value }) => (
        <span
          className={value === 'Active' ? 'status-active' : 'status-terminated'}
        >
          {value}
        </span>
      ),
      Footer: '',
    },
    {
      Header: 'Default',
      accessor: 'default',
      Footer: '',
      width: 60,
      minWidth: 50,
      maxWidth: 80,
      Cell: ({ row }) => (
        <div className="account-preference-dual-coverage-radio">
          <RadioInput
            key={row?.id}
            label=""
            name="dual-coverage-default"
            className="cursor-pointer d-flex"
            value={row?.id}
            checked={selectedRow?.id === row?.original?.id}
            defaultChecked={row?.original?.default}
            onChange={(e) => {
              onDualCoverageRadioChange(row?.values);
              if (
                typeof document.getElementById('pgHeadingTitle') !==
                  'undefined' &&
                document.getElementById('pgHeadingTitle') !== null
              ) {
                document
                  .getElementById('pgHeadingTitle')
                  .removeAttribute('tabIndex');
              }
            }}
            ariaLabel="Click to select default account preference"
          />
        </div>
      ),
    },
  ];

  return columnsList;
};
